import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripProtocol'
})
export class StripProtocolPipe implements PipeTransform
{
  public transform(value: string, maxLength: number = 30): string
  {
    if (!value)
    {
      return '';
    }

    let clean = value.replace(/^https?:\/\//, '').replace(/^www\./, '');
    if (clean.length > maxLength)
    {
      clean = clean.substring(0, maxLength) + '...';
    }

    return clean;
  }
}
